import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loginUser } from '../api';
import { showError } from '../utils';

const storedAuth = JSON.parse(localStorage.getItem('authData')) || null;

export const login = createAsyncThunk(
    'auth/login',
    async ({ email, password }, { rejectWithValue }) => {
        try {
            // Chiamata spostata in api.js
            const data = await loginUser({ email, password });
            if (data.code !== 200) {
                return rejectWithValue(data.error_messages);
            }
            return data.data; // { name, user, token }
        } catch (err) {
            return rejectWithValue([err.message]);
        }
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState: { authData: storedAuth, status: 'idle', error: null },
    reducers: {
        logout(state) {
            state.authData = null;
            localStorage.removeItem('authData');
        }
    },
    extraReducers: builder => {
        builder
            .addCase(login.pending, state => { state.status = 'loading'; })
            .addCase(login.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.authData = action.payload;
                localStorage.setItem('authData', JSON.stringify(action.payload));
            })
            .addCase(login.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                showError(action.payload);
            });
    }
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;